<template>
    <div>
        <div style="margin: 3px 0px 3px 0px;padding: 3px;background: white">
            <el-row style="display: flex">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-folder-add" circle @click="add" type="primary"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="批量删除" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-delete-solid" circle @click="ifBatchDel()" type="primary"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="二维码" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-s-grid" circle @click="getBatchQRCode()" type="primary"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-refresh-right" circle @click="reflash" type="success"></el-button>
                </el-tooltip>
               <!-- <el-tooltip class="item" effect="dark" content="产品编码查询" placement="bottom" style="margin-left: 8px">
                <el-input v-model="productcode" type="text"
                          @click.native.prevent="showProductCode"
                          @keyup.enter.native="showProductCode"
                          suffix-icon="el-icon-search"
                          size="medium" style="width:200px;margin-left: 8px"></el-input></el-tooltip>-->
                 <el-tooltip class="item" effect="dark" content="下载模板" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-download" circle @click="download" type="warning"></el-button>
                </el-tooltip>
                  <el-upload
                        class="upload-demo"
                        :action="uploadurl"
                        :file-list="fileList"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :auto-upload="true"
                        :show-file-list="false"
                        :limit="1">
                    <el-tooltip class="item" effect="dark" content="上传" placement="bottom" style="margin-left: 8px">
                     <el-button icon="el-icon-upload2" circle  type="primary"></el-button>
                   </el-tooltip>
                 </el-upload>
                <!--<el-tooltip class="item" effect="dark" content="产品编码查询" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-search" circle @click="showProductCode" type="success"></el-button>
                </el-tooltip>-->
                <!--<el-tooltip class="item" effect="dark" content="换货" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-sort" circle @click="isShowChange" type="success"></el-button>
                </el-tooltip>-->
            </el-row>
            <el-row>
                <el-select v-model="status" clearable size="medium" style="margin-left: 8px">
                    <el-option key="0" label="草稿" value="0"></el-option>
                    <el-option key="1" label="已使用" value="1"></el-option>
                    <el-option key="2" label="未使用" value="2"></el-option>
                    <el-option key="3" label="冻结" value="3"></el-option>
                    <el-option key="4" label="退货" value="4"></el-option>
                    <el-option key="5" label="赠送" value="5"></el-option>
                </el-select>
                <el-input v-model="queryKey" type="text"
                          @click.native.prevent="getView"
                          @keyup.enter.native="getView"
                          suffix-icon="el-icon-search"
                          size="medium" style="width:200px;margin-left: 8px"></el-input>
                <el-tooltip class="item" effect="dark" content="查询" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-search" circle @click="getView"></el-button>
                </el-tooltip>
            </el-row>
        </div>
        <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productname" label="品名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productmodel" label="型号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productspecs" label="规格"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productcode" label="产品唯一编码"></el-table-column>
            <el-table-column show-overflow-tooltip prop="retailprice" label="零售价" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="provincialprice" label="省代价格" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cityprice" label="市代价格" align="right"></el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="dealeriid" label="经销商ID"></el-table-column>-->
            <el-table-column show-overflow-tooltip prop="status" label="状态">
                <template scope="scope">
                    <span>{{expstatus(scope.row.status)}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="trackingnum" label="快递单号"></el-table-column>
            <el-table-column fixed="right" label="操作" width="240">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editInfo(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click.native.prevent="confirmdel(scope.row)" type="text" size="mini">删除</el-button>
                    <el-button @click.native.prevent="showChange(scope.row)" type="text" size="mini">换货</el-button>
                    <el-button @click.native.prevent="showProductCode(scope.row)" type="text" size="mini">编码查询</el-button>
                    <el-button @click.native.prevent="getQRCode(scope.row)" type="text" size="mini">二维码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="isShowEdit" width="80%" :close-on-click-modal="false">
            <el-row style="margin-top: 20px">
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="8rem" label-position="left" size="small">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="品名">
                                    <el-select filterable v-model="dataDetail.productiid" size="mini" @change="getprice">
                                        <el-option v-for="item in arrproductname" :key="item.iid" :label="item.productname" :value="item.iid"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="产品唯一编码">
                                    <el-input v-model="dataDetail.productcode" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="状态">
                                    <el-select filterable v-model="dataDetail.status" size="mini">
                                        <el-option v-for="item in arrstatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="快递单号">
                                    <el-input v-model="dataDetail.trackingnum" size="mini"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="零售价">
                                    <el-input v-model="dataDetailProduct.retailprice" type="number" size="mini" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="省代价格">
                                    <el-input v-model="dataDetailProduct.provincialprice" type="number" size="mini" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="市代价格">
                                    <el-input v-model="dataDetailProduct.cityprice" type="number" size="mini" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false">关闭</el-button>
				<el-button type="primary" @click="onSubmit">保存</el-button>
			</span>
        </el-dialog>

        <el-dialog :visible.sync="isShowCode" width="80%" :close-on-click-modal="false">
            <el-row>
                <el-col :span="24">
                    <el-divider content-position="left">订单信息</el-divider>
                    <el-form :inline="true" :model="dataOrder" class="demo-form-inline" label-width="8rem" label-position="left" size="small">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="产品名称">
                                    {{dataOrder.productname}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="订单编号">
                                    {{dataOrder.ordercode}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="下单时间">
                                    {{dataOrder.ordertime}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="状态">
                                    {{exporderstatus(dataOrder.status)}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-divider content-position="left">销售信息</el-divider>
                    <el-form :inline="true" :model="dataSale" class="demo-form-inline" label-width="8rem" label-position="left" size="small">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="销售编码">
                                    {{dataSale.salecode}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="销售产品">
                                    {{dataSale.productname}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="销售区域">
                                    {{dataSale.salearea}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="销售状态">
                                    {{dataSale.status}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowCode = false">关闭</el-button>
			</span>
        </el-dialog>

        <el-dialog :visible.sync="isShowChange" width="40%" :close-on-click-modal="false">
            <div style="width:60%;margin:auto;text-align: center">
                <el-input v-model="oldproductcode" size="mini" disabled="true"></el-input>
                <i class="el-icon-sort"></i>
                <el-input v-model="newproductcode" size="mini" placeholder="交换后的产品编码"></el-input>
            </div>
            <!--<el-row>
                <el-col :span="8">
                    <el-form-item label="原编码">
                        {{oldproductcode}}
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <i class="el-icon-sort"></i>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="新编码">
                        <el-input v-model="newproductcode" size="mini"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>-->
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowChange = false">关闭</el-button>
                <el-button type="primary" @click="submitChange">保存</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';

    export default {
        data() {
            return {
                dataSet: [], // 主表数据
                dataDetail: {},
                dataDetailProduct:{},
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                user: "",
                usercode: "",
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 250, // 主表高度
                queryKey: "",
                SortList: [],              
                ScreenList: [],
                isShowEdit: false, // 是否显示编辑页面
                arrproductname:[],
                arrstatus:[{
                    value: '0',
                    label: '草稿'
                },{
                    value: '1',
                    label: '已使用'
                },{
                    value: '2',
                    label: '未使用'
                },{
                    value: '3',
                    label: '冻结'
                },{
                    value: '4',
                    label: '退货'
                },{
                    value: '5',
                    label: '赠送'
                }],
                productcode: "",
                isShowCode: false,
                dataOrder: {},
                dataSale: {},

                isShowChange: false,
                oldproductcode: "",
                newproductcode: "",
                status: "",
                fileList:[],
                uploadurl:'',
                selectData: [] //多选
            };
        },
        mounted: function () {
            let that = this
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.token = that.userData.token
            that.user = that.userData.username
            that.usercode = that.userData.Login_Code
            let parm = {
                tableName: "sys_product",
                columnName: "productname"
            }
            $.ajax({
                url: Common.Url + 'BaseData/Query?token=' + that.token,
                type: 'post',
                async: false,
                data: JSON.stringify(parm),
                contentType: 'application/json',
                success: function(res) {
                    if (res.Success == 1) {
                        that.arrproductname = res.DataContent;
                    } else {
                        //Message.error(res.Msg);
                    }
                },
                error: function(xhr, errorType, error) {
                    //Message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                }
            });
            that.getView();
            let param = {
                    TemplateID: 1,
                    UserName: that.user,
                    UserCode: that.usercode,
             };
            let strparam = JSON.stringify(param);
            that.uploadurl =  Common.Url + 'Sys/Import?JsonParam='+strparam;
        },
        methods: {
            getprice(row) {
                let that = this
                for(let i = 0;i<that.arrproductname.length;i++){
                    if(row == that.arrproductname[i].iid){
                        that.dataDetailProduct.retailprice = that.arrproductname[i].retailprice
                        that.dataDetailProduct.provincialprice = that.arrproductname[i].provincialprice
                        that.dataDetailProduct.cityprice = that.arrproductname[i].cityprice
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val
                this.SelectIndexs = val;
                this.getView();
            },
            reflash() {
                let that = this
                that.queryKey = ""
                that.status = ""
                that.getView()
            },
            getView() {
                let that = this
                that.loading = true
                let parm = {
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                    QueryKey: that.queryKey,
                    iid: "",
                    SortList: that.SortList,
                    ScreenList: that.ScreenList,
                    status: that.status
                };
                that.$http.urlpost('/SysProductCode/View', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            editInfo(row){
                let that = this
                that.isAdd = false;
                that.dataDetail = row
                let parm = {
                    tableName: "sys_product",
                    columnName: "",
                    iid: that.dataDetail.productiid
                }
                that.$http.urlpost('/BaseData/Detail', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent.length>0){
                            that.dataDetailProduct = res.DataContent[0]
                        }
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
                that.isShowEdit = true
            },
            onSubmit() {
                let that = this
                let datetime = Common.methods.getDatetime
                that.dataDetail.modifypersoncode = that.usercode
                that.dataDetail.modifypersonname = that.user
                that.dataDetail.modifytime = datetime
                let parm = that.dataDetail
                that.$http.urlpost('/SysProductCode/Edit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isShowEdit = false
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            add(){
                let that = this
                that.isAdd = true;
                let datetime = (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()).toString()
                that.dataDetail = {
                    iid: "",
                    productiid: "",
                    dealeriid: "",
                    saleiid: "",
                    productcode: "",
                    status: "2",
                    trackingnum: "",
                    createpersoncode: that.usercode,
                    createpersonname: that.user,
                    createtime: datetime,
                    modifypersoncode: that.usercode,
                    modifypersonname: that.user,
                    modifytime: datetime,
                    remark: ""
                }
                that.isShowEdit = true
            },
            confirmdel(row){
                let that = this
                that.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.del(row);
                    })
                    .catch(() => {});
            },
            del(row) {
                let that = this
                let parm ={
                    iid: row.iid,
                    modifytime: row.modifytime,
                    createpersonname: that.user
                }
                that.$http.urlpost('/SysProductCode/Delete', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            showProductCode(value) {
                let that = this
                let parm = {
                    productcode: value.productcode
                }
                that.$http.urlpost('/SysProductCode/ShowOrderSaleInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowCode = true
                        if(res.DataContent.v_order != null){
                            that.dataOrder = res.DataContent.v_order
                        } else {
                            that.dataOrder = {}
                        }
                        if(res.DataContent.v_sale != null){
                            that.dataSale = res.DataContent.v_sale
                        } else {
                            that.dataSale = {}
                        }
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            showChange(value) {
                let that = this
                that.oldproductcode = value.productcode
                that.isShowChange = true
            },
            submitChange() {
                let that = this
                let parm = {
                    oldproductcode: that.oldproductcode,
                    newproductcode: that.newproductcode
                }
                that.$http.urlpost('/SysProductCode/Exchange', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            expstatus(value){
                if(value == 0){
                    return '草稿'
                } else if(value == 1){
                    return '已使用'
                } else if(value == 2){
                    return '未使用'
                } else if(value == 3){
                    return '冻结'
                } else if(value == 4){
                    return '退货'
                } else if(value == 5){
                    return '赠送'
                } else {
                    return ''
                }
            },
            download(){
                let that = this
                let parm = {
                    TemplateID: 1,
                };
                that.$http.urlpost('/Template/Download', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.Key;
						window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });

            },
            handleChange(file, fileList){
                 let that = this;
                 that.loading = true;
            },
            //上传成功回调
            handleSuccess(res, file, fileList){
                let that = this;
                that.loading = false;
                that.fileList=[];
                console.log(res);
                if(res.Success==0){
                    that.$message.error(res.Msg);
                }else{
                    that.$message.success(res.Msg);
                }
                if(res.Key!=null){
                    let hrefurl = Common.Url + res.Key;
                    window.open(hrefurl);
                }
                 that.getView();
            },
            handleError(err, file, fileList){
                let that = this;
                that.fileList=[];
                that.$message.error('上传失败:' + err)
            },
            getQRCode(value){
                let that = this;
                let temarray = [];
                temarray.push(value.productcode);
                let parm = {
                    productcodes: temarray
                }
                that.$http.urlpost('/Sys/ExportQRCode', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.Key;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            getBatchQRCode(){
                let that = this
                let parm = {
                    productcodes: that.selectCodeData
                }
                that.$http.urlpost('/Sys/ExportQRCode', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.Key;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                that.selectCodeData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i].iid);
                    that.selectCodeData.push(val[i].productcode)
                }
            },
            //批量删除
            ifBatchDel(){
                let that = this
                that.$confirm('是否批量删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.batchDel();
                    })
                    .catch(() => {});
            },
            batchDel(){
                let that = this
                let iids = Common.methods.arrToStr(that.selectData)
                let parm ={
                    iid: iids,
                    createpersonname: that.user
                }
                that.$http.urlpost('/SysProductCode/Delete', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView()
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            exporderstatus(value) {
                if (value == 0) {
                    return '草稿'
                } else if (value == 1) {
                    return '新建'
                } else if (value == 2) {
                    return '提交'
                } else if (value == 3) {
                    return '发货'
                } else if (value == 4) {
                    return '签收'
                } else {
                    return ''
                }
            },
        }
    };
</script>

<style scoped lang="less">
</style>
